import { useApplicationContext } from '../../utils/applicationContext';

import { MortgageContainer, MortgageContainerMobile } from '../MortgageContainer';
import * as React from 'react';
import { Section } from '../../components/Section';
import { Responsive, useDeviceType } from '@cian/ui-kit';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { Microfrontend } from '@cian/mf-react';
import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { ContentContainer } from '../../components/ContentContainer';

const MORTGAGE_COMPONENTS = {
  desktop: MortgageContainer,
  tablet: MortgageContainerMobile,
  phone: MortgageContainerMobile,
};

export const MortgageCalculatorContainer = () => {
  const { config } = useApplicationContext();

  const device = useDeviceType();

  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);

  // TODO: После того как будем удалять флаги, нужно будет переделать данный компонент, оставив только условие с манифестом
  if (manifest) {
    const MicrofrontendComponent = (
      <Microfrontend name={manifest.microfrontendName} image={manifest.imageVersion} runtime={manifest.runtimeName} />
    );

    return (
      <Section>
        <Responsive desktop>{MicrofrontendComponent}</Responsive>
        <Responsive tablet phone>
          <ContentContainer>{MicrofrontendComponent}</ContentContainer>
        </Responsive>
      </Section>
    );
  }

  const MortgageCalculatorComponent = MORTGAGE_COMPONENTS[device];

  return <MortgageCalculatorComponent />;
};
